/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type UserDimension = (typeof UserDimension)[keyof typeof UserDimension];

export const UserDimension = {
  team: 'team',
  market: 'market',
  tenure: 'tenure',
  llm_model: 'llm_model',
  llm_provider: 'llm_provider',
} as const;
